import { render, staticRenderFns } from "./MesPreferences.vue?vue&type=template&id=25050231&scoped=true"
import script from "./MesPreferences.vue?vue&type=script&lang=js"
export * from "./MesPreferences.vue?vue&type=script&lang=js"
import style0 from "./MesPreferences.vue?vue&type=style&index=0&id=25050231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25050231",
  null
  
)

export default component.exports